export const environment = {
  production: false,
  // baseUrl: 'https://api-staging.kyrainnovations.com/v1/' #TODO: Reenable this once staging is migrated from digital ocean to AWS Server
  baseUrl: 'https://api-sandbox.kyrainnovations.com/v1/'
};
